
const UserReducer = (state = { user: {}, explore: {} }, action) => {
  switch (action.type) {
    case "USER":
      return {
        ...state,
        user: action.payload,
      };
    case "EXPLORE":
      return {
        ...state,
        explore: action.payload,
      };
    default:
      return state;
  }
};

export default UserReducer;
